import { render, staticRenderFns } from "./BroadcastsProfile.vue?vue&type=template&id=0a00794b&scoped=true&"
import script from "./BroadcastsProfile.vue?vue&type=script&lang=ts&"
export * from "./BroadcastsProfile.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastsProfile.vue?vue&type=style&index=0&id=0a00794b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a00794b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VCol,VRow,VTooltip})
